export const krw = (price?: number | string, noUnit = false) => {
  const _price = price || '0'
  return `${_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${noUnit ? '' : '원'}`
}

const format = { krw }

export default format
